// import external dependencies
import 'jquery';
import 'bootstrap';
import 'scrollpos-styler';
import 'slick-slider';
import 'jquery-ui/ui/widgets/autocomplete';

import global from './util/global';
import jobSearch from './util/jobSearch';
import etudeSearch from './util/etudeSearch';
import actus from './util/actus';

import menu from './util/menu';
import slider from './util/slider';
import carto from './util/carto';
import anchor from './util/anchor';

import './util/contact';
import './util/iframe_youtube';
import formationSearch from './util/formationSearch';
import searchInFormationType from './util/searchInFormationType';

(function ($) {
  $(function () {
    // Fourre Tout
    global.load();
    global.loadSearch();

    jobSearch.load();
    etudeSearch.load();
    formationSearch.load();
    actus.load();
    searchInFormationType.load();

    carto.loadFamilyHeight();
    $(window).resize(function() {
      carto.loadFamilyHeight();
    });
    carto.loadHoverFamily();

    anchor.load();
    anchor.onload_go_to();
    menu.load();

    slider.load();
  });

})(jQuery);



// WEBPACK FOOTER //
// ./scripts/main.js